import IndigoApiError from './IndigoApiError';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyError = any;
export default class IndigoLoginError extends IndigoApiError {
    public type: IndigoLoginErrorType;
    public innerError: AnyError;

    public constructor(type: IndigoLoginErrorType, innerError?: AnyError) {
        super('Login failed');
        this.type = type;
        this.innerError = innerError;
    }
}

export enum IndigoLoginErrorType {
    GENERIC_LOGIN_ERROR = 'GENERIC_LOGIN_ERROR',
    INVALID_CREDENTIALS_LOGIN_ERROR = 'INVALID_CREDENTIALS_LOGIN_ERROR',
    MISSING_CREDENTIALS_LOGIN_ERROR = 'MISSING_CREDENTIALS_LOGIN_ERROR',
    NOT_AUTHORIZED_LOGIN_ERROR = 'NOT_AUTHORIZED_LOGIN_ERROR',
    RESTRICTED_IP_LOGIN_ERROR = 'RESTRICTED_IP_LOGIN_ERROR',
}
